var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableBasePriceBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 791,
    height: 138,
    viewBox: "0 0 791 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.34004,
    y: -4.55489,
    width: 799.168,
    height: 146.5
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.28px)",
      clipPath: "url(#bgblur_0_16246_179706_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4.55489,
    d: "M53.2744 0.569336H775.275C783.245 0.569468 789.706 7.03026 789.706 15V80.5244C789.706 84.8491 787.767 88.9378 784.437 91.6738L784.109 91.9346L730.033 133.802C727.504 135.76 724.397 136.822 721.199 136.822H15.2275C5.41941 136.822 -1.48331 127.27 1.47754 118.013L1.62598 117.572L39.6729 10.1807C41.714 4.41984 47.1627 0.569535 53.2744 0.569336Z",
    fill: "url(#paint0_radial_16246_179706)",
    stroke: "url(#paint1_linear_16246_179706)",
    strokeWidth: 1.13872
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_16246_179706_clip_path",
    transform: "translate(4.34004 4.55489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2744 0.569336H775.275C783.245 0.569468 789.706 7.03026 789.706 15V80.5244C789.706 84.8491 787.767 88.9378 784.437 91.6738L784.109 91.9346L730.033 133.802C727.504 135.76 724.397 136.822 721.199 136.822H15.2275C5.41941 136.822 -1.48331 127.27 1.47754 118.013L1.62598 117.572L39.6729 10.1807C41.714 4.41984 47.1627 0.569535 53.2744 0.569336Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16246_179706",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(392.133 68.6958) scale(344.789 84.1364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#004282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#04397B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#112369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16246_179706",
    x1: -186.083,
    y1: 68.6958,
    x2: 790.275,
    y2: 68.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#118EDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableBasePriceBg);
export default __webpack_public_path__ + "static/media/tableBasePriceBg.6853e6cb8afcb0025de0a20063b0c4d7.svg";
export { ForwardRef as ReactComponent };